import React from 'react';
import $ from 'jquery';
import './Study.css';
import Footer from '../Footer/Footer';
import Spinner from '../Spinner/Spinner';
import { withRouter } from "react-router";
import { withAuth } from "../../app/util/HOC";
import { PieChart } from 'react-minimal-pie-chart';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
export class StudyCenterStudent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 50,
            loading: false,
            learningObjectiveProgressVOList: null,
            loLength: 0,
            chapterNavTitle: "",
            bookISBN: "",
            bookTitle: "",
            bookVO: JSON.parse(localStorage.getItem('bookVO')),
            userVO: JSON.parse(localStorage.getItem('userVO')),
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false",
            serviceCompletion: false
        };
        this.expandClickEvent = this.expandClickEvent.bind(this);
        this.navigateToAssessment = this.navigateToAssessment.bind(this);
    }
    componentDidMount = () => {
        this.fetchChapterLO();
        document.title = `${this.state.bookVO !== null ? this.state.bookVO.bookTitle : ""} | ${this.state.bookVO !== null ? this.state.bookVO.navbarTitle : ""} | Study Center | Aspen Publishing`;
    }
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.match.params.chapterid !== prevProps.match.params.chapterid) {
            this.fetchChapterLO();
        }
        document.title = `${this.state.bookTitle !== null ? this.state.bookTitle : this.state.bookVO.bookTitle} | ${this.state.chapterNavTitle !== null ? this.state.chapterNavTitle : this.state.bookVO.navbarTitle} | Study Center | Aspen Publishing`;
    }
    fetchChapterLO() {
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "StudyCenter",
                    "pageNavigatingTo": "StudyCenterQuestion",
                    "lastReadBookId": "298",
                    "lastReadChapterId": "30a09557-455c-11eb-bd93-ab145ca5521d",
                    "lastViewedLearningObjectId": ""
                },
                sessionVO: {
                    "appType": "web",
                    "browserName": localStorage.getItem('browserName'),
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                },
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
            },
            "bookVO": {
                //"bookId": "298"
                "bookISBN": this.props.match.params.isbn,
                "chapterId": this.props.match.params.chapterid
            },
            "chapterVO": {
                "chapterId": this.props.match.params.chapterid
            }
        }
        if (this.state.userVO.userRoleId === "5") {
            reqData.classVO = {
                "classId": "-999"
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        this.setState({ "loading": true })
        fetch(localStorage.getItem('ENV') + "/manageClassWebService/getStudyCenterViewForProfOrStudentRv", requestOptions1)
            .then(response => response.json())
            .then(data => {
                this.setState({ loading: false })
                if (data) {
                    if (data.status === "true") {
                        if (data.bookVO) {
                            if (data.bookVO.totalChapterPageCount === "0")
                                this.props.history.push(`/study/${this.props.match.params.isbn}/${data.bookVO.chapterId}`);
                        }
                        if (data.chapterLearningObjectiveVO) {
                            var chapterLearningObjectiveVO = data.chapterLearningObjectiveVO;
                            if (chapterLearningObjectiveVO && chapterLearningObjectiveVO.learningObjectiveProgressVOList) {
                                var learningObjectiveProgressVOList = chapterLearningObjectiveVO.learningObjectiveProgressVOList
                                learningObjectiveProgressVOList = Array.isArray(learningObjectiveProgressVOList) ?
                                    learningObjectiveProgressVOList : [learningObjectiveProgressVOList]
                                localStorage.setItem("sumOfAllQuestions", chapterLearningObjectiveVO.sumOfAllQuestions)
                                var currBook = {
                                    "bookISBN": data.chapterVO.bookISBN,
                                    "bookTitle": data.chapterVO !== undefined ? data.chapterVO.bookTitle : "",
                                    "chapterId": data.chapterVO !== undefined ? data.chapterVO.chapterId : ""
                                }
                                this.setState({
                                    "learningObjectiveProgressVOList": learningObjectiveProgressVOList,
                                    "loLength": learningObjectiveProgressVOList.length,
                                    "chapterNavTitle": data.chapterVO !== undefined ? data.chapterVO.navbarTitle : "",
                                    "bookISBN": data.chapterVO !== undefined ? data.chapterVO.bookISBN : "",
                                    "bookTitle": data.chapterVO !== undefined ? data.chapterVO.bookTitle : "",
                                    "bookVO": data.bookVO, "serviceCompletion": true,
                                    "loading": false
                                })
                            }
                            this.collapseAll();
                        }
                    } else {
                        if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
                this.setState({ "serviceCompletion": true, "loading": false })
            });;
    }
    collapseAll() {
        let i = 0;
        for (i = 0; i < this.state.loLength; i++) {
            if (document.getElementById("secondMenuITag" + i).className !== undefined) {
                document.getElementById("secondMenuITag" + i).className = "fa fa-plus";
                document.getElementById("secondMenuDiv" + i).classList.add("hiddenDiv");
                document.getElementById("hiddenExpand" + i).classList.remove("display-none");
            }
        }
    }
    expandClickEvent(event) {
        if (event.target.className === "fa fa-plus") {
            event.target.className = "fa fa-minus";
            document.getElementById("secondMenuDiv" + event.target.getAttribute("index")).classList.remove("hiddenDiv");
            document.getElementById("hiddenExpand" + event.target.getAttribute("index")).classList.add("display-none");
            $(`#secondMenuITag${event.target.getAttribute("index")}`).attr('aria-label', 'Collapse Topic');
            $(`#secondMenuITag${event.target.getAttribute("index")}`).attr('aria-pressed', 'true');
        }
        else {
            event.target.className = "fa fa-plus";
            document.getElementById("secondMenuDiv" + event.target.getAttribute("index")).classList.add("hiddenDiv");
            document.getElementById("hiddenExpand" + event.target.getAttribute("index")).classList.remove("display-none");
            $(`#secondMenuITag${event.target.getAttribute("index")}`).attr('aria-label', 'Expand Topic');
            $(`#secondMenuITag${event.target.getAttribute("index")}`).attr('aria-pressed', 'false');
        }
    }
    expandClickOnNameEvent = (event) => {
        var plus = document.getElementById("secondMenuITag" + event.target.getAttribute("index"));
        if (plus.getAttribute("index") == event.target.getAttribute("index")) {
            if (plus.className == "fa fa-plus") {
                plus.className = "fa fa-minus";
                document.getElementById("secondMenuDiv" + event.target.getAttribute("index")).classList.remove("hiddenDiv");
                document.getElementById("hiddenExpand" + event.target.getAttribute("index")).classList.add("display-none");
            }
            else {
                plus.className = "fa fa-plus";
                document.getElementById("secondMenuDiv" + event.target.getAttribute("index")).classList.add("hiddenDiv");
                document.getElementById("hiddenExpand" + event.target.getAttribute("index")).classList.remove("display-none");
            }
        }
    }
    navigateToAssessment = (e) => {
        const revQuestTyp = e.currentTarget.getAttribute("questionType");
        const questType = (
            revQuestTyp === "multichoice" ? "/mcq/" : revQuestTyp === "flashcard" ? "/flashcard/" :
                revQuestTyp === "hypothetical" ? "/shortanswer/" : revQuestTyp === "essay" ? "/essay/" :
                    revQuestTyp === "issuespotting" ? "/issuespotting/" : null
        );
        if (questType)
            this.props.history.push(`/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid + questType + e.currentTarget.getAttribute("learningObjectiveId")}`);
    }
    openWatchVideoPage = (e) => {
        const vidTyp = e.currentTarget.getAttribute("explainertype");
        const expType = (vidTyp === "video" ? "/watchvideo/" : vidTyp === "text" ? "/readexplanation/" : null);
        if (expType)
            this.props.history.push(`/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid + expType + e.currentTarget.getAttribute("learningObjectiveId")}`);
    }
    handleExpandStudyHeading = (e) => {
        if (e.key === 'Enter') {
            this.expandClickOnNameEvent(e);
        }
    }
    handleQuestionType = (e) => {
        if (e.key === 'Enter') {
            this.navigateToAssessment(e);
        }
    }
    handleWatchVideoPage = (e) => {
        if (e.key === 'Enter') {
            this.openWatchVideoPage(e);
        }
    }
    render() {
        let studyPieChart = (practice, LoId) => {
            var studyData = []
            studyData.push({ title: 'correct', value: parseInt(practice.totalCorrectAnswer), color: '#85BC20' })
            studyData.push({ title: 'incorrect ', value: parseInt(practice.totalWrongAnswer), color: '#E5202E' })
            studyData.push({ title: 'needs practice', value: parseInt(practice.totalPartialCorrect), color: '#7FBCE1' })
            studyData.push({ title: 'unanswered', value: parseInt(practice.totalUnAnswered), color: '#ECECEC' })
            return (
                <PieChart startAngle={270} lengthAngle={360} lineWidth={35} key={LoId + "_" + practice.questionType}
                    id={LoId + "_" + practice.questionType} data={studyData}
                />
            )
        }
        let decimalFormat = (value) => {
            if (!isNaN(value))
                return parseFloat(value % 1 === 0 ? Math.round(value) : value.toFixed(2))
        }
        return (
            <React.Fragment>
                <div className="col-lg-12">
                    <div className="row greyDiv">
                        <div className="col-lg-10 headingDiv">
                            <span className="insightProperty">{this.state.bookTitle}</span><br />
                            <span className="insightHeading">{this.state.chapterNavTitle}</span>
                        </div>
                    </div>
                    <div className="row">
                        <Spinner
                            loading={this.state.loading}
                            imageSrc={loaderColors1}
                            overlayBackground="rgba(0,0,0,0.5)"
                            label="Loading study center"
                        />
                        <div className="studyDiv">
                            {this.state.learningObjectiveProgressVOList ?
                                this.state.learningObjectiveProgressVOList.map((learningObjective, index) => (
                                    learningObjective.learningObjId ?
                                        <div>
                                            {parseInt(learningObjective.totalNumberOfQuestionInLearningObjective) > 0 ?
                                            <>
                                                <div>
                                                    <span style={{ cursor: 'pointer' }} className="studyHeading" id="secondMenu" index={index} onClick={this.expandClickOnNameEvent} tabIndex="0" onKeyDown={(e) => this.handleExpandStudyHeading(e)}>{learningObjective.learningObjName}</span>
                                                    <i data-testid={`expand_${learningObjective.learningObjId}`} style={{ float: 'right', cursor: 'pointer' }} id={"secondMenuITag" + index} className="fa fa-plus" index={index} onClick={this.expandClickEvent} role="button" aria-pressed="false" aria-label="Expand Topic"></i>
                                                </div>
                                                
                                                <span className="insightProperty">{learningObjective.learningObjDescription}</span>
                                                <br />
                                                
                                                <span className="insightProperty">
                                                    {learningObjective.totalNumberOfQuestionInLearningObjective} {parseInt(learningObjective.totalNumberOfQuestionInLearningObjective) > 1 ? " questions" : " question"}
                                                </span> 
                                                <br />
                                                
                                                <div>
                                                    <div className="multicolor-bar">
                                                        <br />
                                                        <ProgressBar>
                                                            <ProgressBar className="progress-greenColor" aria-label={`${learningObjective.learningObjName}: correctly answered questions percentage`} now={decimalFormat((learningObjective.totalCorrectAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)} key={1} />
                                                            <ProgressBar className="progress-redColor" aria-label={`${learningObjective.learningObjName}: incorrectly answered questions percentage`} now={decimalFormat((learningObjective.totalWrongAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)} key={2} />
                                                            <ProgressBar className="progress-blueColor" aria-label={`${learningObjective.learningObjName}: practice needed questions percentage`} now={decimalFormat((learningObjective.totalPartialCorrectInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)} key={3} />
                                                            <ProgressBar className="progress-greyColor" aria-label={`${learningObjective.learningObjName}: unanswered questions percentage`} now={100 - (decimalFormat((learningObjective.totalCorrectAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100) +
                                                                decimalFormat((learningObjective.totalWrongAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100) +
                                                                decimalFormat((learningObjective.totalPartialCorrectInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100))} key={4} />
                                                        </ProgressBar>
                                                    </div>
                                                    <span className="insightProperty" >
                                                        <div className="value"    >
                                                            <span>{decimalFormat((learningObjective.totalCorrectAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)}%&nbsp;Correct&nbsp;|&nbsp;</span>
                                                            <span>{decimalFormat((learningObjective.totalWrongAnswerInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)}%&nbsp;Incorrect&nbsp;|&nbsp;</span>
                                                            <span>{decimalFormat((learningObjective.totalPartialCorrectInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)}%&nbsp;Needs practice &nbsp;|&nbsp;</span>
                                                            <span>{decimalFormat((learningObjective.totalUnAnsweredInLearningObjective / learningObjective.totalNumberOfQuestionInLearningObjective) * 100)}%&nbsp;Unanswered&nbsp;</span>
                                                        </div>
                                                    </span>
                                                </div>
                                                <hr id={"hiddenExpand" + index} />
                                                
                                                <div id={"secondMenuDiv" + index} index={index} className="hiddenDiv">
                                                    <br />
                                                    {
                                                        learningObjective.learningObjectiveExplainerResponseList.filter(x => x.totalQuestions > 0).length > 0 ?
                                                            <div className="explanatorySection">
                                                                <span className="insightHeading">Learn</span>
                                                                <br /> <br />
                                                                {learningObjective.learningObjectiveExplainerResponseList.filter(x => x.totalQuestions > 0).map((learn, index) => (
                                                                    <span>
                                                                        <div className="d-flex">
                                                                            <div data-testid={`watchVideo_${learningObjective.learningObjId}`} aria-hidden='true' className={learn.explainerType === "video" ? "videoIcon" : learn.explainerType === "audio" ? "audioIcon" : "studyFileIcon"} explainerType={learn.explainerType} learningObjectiveId={learningObjective.learningObjId} onClick={(e) => this.openWatchVideoPage(e)}>
                                                                                <i className={learn.explainerType === "video" ? "fas fa-video" : learn.explainerType === "audio" ? "audioIcon" : "fas fa-file-alt"} aria-hidden='true' style={{ fontSize: '18px', color: '#007AC3' }}></i>
                                                                            </div>
                                                                            &nbsp;
                                                                            <div data-testid={`watchVideoPage_${learningObjective.learningObjId}`} className="insightProperty my-auto" explainerType={learn.explainerType} learningObjectiveId={learningObjective.learningObjId} onClick={(e) => this.openWatchVideoPage(e)} style={{ cursor: 'pointer' }} tabIndex="0" onKeyDown={(e) => this.handleWatchVideoPage(e)} >
                                                                                {learn.explainerType === "video" ? "Watch a video" : learn.explainerType === "audio" ? "Hear an Audio" : "Read an explanation"}
                                                                            </div>
                                                                        </div>
                                                                        <br /> <br />
                                                                    </span>
                                                                ))}
                                                            </div> : null
                                                    }
                                                    {learningObjective.learningObjectiveResponseList.filter(x => x.totalQuestions > 0).length > 0 ?
                                                        <div className="practiceSection">
                                                            <span className="insightHeading">Practice</span>
                                                            <br />  <br />
                                                            <div className="row cusorPointer m-auto setResponsiveWidth">
                                                                {learningObjective.learningObjectiveResponseList.filter(x => x.totalQuestions > 0).map((practice, index) => (
                                                                    <div data-testid={`learningObjective_${learningObjective.learningObjId}`} learningObjectiveId={learningObjective.learningObjId} questionType={practice.questionType}
                                                                        style={{ textAlign: 'center' }} onClick={this.navigateToAssessment} className="setGraphDiv">
                                                                        <span data-testid={`learningObjective_key_${learningObjective.learningObjId}`} learningObjectiveId={learningObjective.learningObjId} questionTypeTitle={practice.questionType} questionType={practice.questionType} className="insightProperty" tabIndex="0" onKeyDown={(e) => this.handleQuestionType(e)}>
                                                                            {practice.questionType === "multichoice" ? "Multiple Choice" :
                                                                                practice.questionType === "flashcard" ? "Flash Cards" :
                                                                                    practice.questionType === "hypothetical" ? "Short Answer" :
                                                                                        practice.questionType === "essay" ? "Essay" :
                                                                                            practice.questionType === "issuespotting" ? "Issue Spotting" : ""}   <br />
                                                                            {practice.totalQuestions}  {parseInt(practice.totalQuestions) > 1 ? " questions" : " question"}</span>
                                                                        <div aria-hidden='true' learningObjectiveId={learningObjective.learningObjId} questionType={practice.questionType} style={{ width: '5rem', margin: 'auto' }}>
                                                                            {studyPieChart(practice, learningObjective.learningObjId)}
                                                                        </div>
                                                                        <span learningObjectiveId={learningObjective.learningObjId} questionType={practice.questionType} className="insightProperty">
                                                                            {decimalFormat((practice.totalCorrectAnswer / practice.totalQuestions) * 100)}% correct <br />
                                                                            {decimalFormat((practice.totalWrongAnswer / practice.totalQuestions) * 100)}% incorrect <br />
                                                                            {decimalFormat((practice.totalPartialCorrect / practice.totalQuestions) * 100)}% needs practice <br />
                                                                            {decimalFormat((practice.totalUnAnswered / practice.totalQuestions) * 100)}% unanswered
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <br />
                                                        </div>
                                                        : null}
                                                    <hr />
                                                </div>
                                                <br />
                                            </>
                                            : null}
                                        </div>
                                        : (this.state.serviceCompletion) ? "No study materials available for this chapter. Select another chapter from the Contents menu above." : ""
                                ))
                                : (this.state.serviceCompletion) ? "No study materials available for this chapter. Select another chapter from the Contents menu above." : ""}
                            <br />
                            <div>
                                <span className="insightHeading">
                                    About the Connected eBook Study Center
                                </span>
                                <br /> <br />
                                <span className="insightProperty">
                                    The content in the Study Center is selected and maintained exclusively by Aspen Publishing and a team of professor reviewers and editors, not by the authors of your book. These materials typically come from one or more of Aspen Publishing's top study aids, including Examples & Explanations, Glannon Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may be created with assistance from AI tools. Study material sources and activity types vary depending on availability for any given chapter, topic, or course.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}
export default withAuth(withRouter(StudyCenterStudent));